package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminUserListItem(
    val id: String,
    @SerialName("display_name") val displayName: String,
    val email: String,
    @SerialName("avatar_url") val avatarUrl: String?,
    @SerialName("account_status") val accountStatus: String,
    @SerialName("created_at") val createdAt: String,
    @SerialName("listing_count") val listingCount: Int,
    @SerialName("report_count") val reportCount: Int
)
